import { Modal, Form, IFormContext } from 'rewire-ui';
import { AreaUpdateInput, IArea }    from '../DataTypes';
import DataMutations                 from '../graphql/Mutations';
import mainPageModel                 from '../main-navigation/MainPageModel';
import { notifications }             from '../ui/Notifications';

export interface IRenameAreaDialogData {
  area: IArea;
}

export class RenameAreaDialogModel extends Modal {
  form:    Form;
  areaId?: string;

  constructor() {
    super('Rename Area');
    this.form = Form.create((form: IFormContext) => ({
      name: form.string().label('Name').validators('required').placeholder('enter area name').autoFocus(),
    }), {}, {updateOnChange: true});
    this.action('cancel')
        .action('save', this.submit, { variant: 'contained', type: 'submit', disabled: () => !this.form.hasChanges });
  }

  reset() {
    this.form.reset();
    this.areaId = undefined;
  }

  load(data: IRenameAreaDialogData) {
    this.reset();
    this.areaId     = data.area.id;
    this.form.value = {name: data.area.name};
    this.open();
  }

  private save = async (): Promise<boolean> => {
    const areaUpdateInput: AreaUpdateInput = {
      id:   this.areaId!,
      name: this.form.field.name.value,
    };
    const result = await DataMutations.updateAreas('', [areaUpdateInput]);

    if (result && result[0]) {
      notifications.success('Area Renamed');
      mainPageModel.updateAreasAndGroups();
      return true;
    }

    notifications.error('Area Renaming Failed');
    return false;
  };

  submit = async () => {
    return await this.form.submitAsync(this.save);
  };
}

const renameAreaDialogModel = new RenameAreaDialogModel();
export default renameAreaDialogModel;
